import { CaseWorkspace } from './CaseWorkspace';

/** Chat tab entry — legal case workspace (text-first dual pane). */
export function Chat(): React.ReactNode {
  return <CaseWorkspace />;
}
